import Highcharts from 'highcharts';
import HC_rounded from 'highcharts-rounded-corners';
import SolidGauge from 'highcharts/modules/solid-gauge';

// Initialize modules
HC_rounded(Highcharts);

// Global flag to track if SolidGauge has been initialized
let solidGaugeInitialized = false;

// Initialize SolidGauge module with error handling
if (!solidGaugeInitialized && typeof Highcharts !== 'undefined' && typeof SolidGauge === 'function') {
  try {
    SolidGauge(Highcharts);
    solidGaugeInitialized = true;
    console.log('SolidGauge module initialized successfully');
  } catch (error) {
    console.error('Failed to initialize SolidGauge module:', error);
  }
}

export * from 'highcharts';

export default Highcharts;
